import React from "react";
import Link from "next/link";

export default React.memo(function ShoppingFeatures() {
  return (
    <section className="bg-light py-9">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-4">
            <div className="d-flex mb-6 mb-lg-0">
              <i className="fe fe-truck font-size-lg text-primary"></i>

              <div className="ml-6">
                <h6 className="heading-xxs mb-1">Free shipping</h6>

                <p className="mb-0 font-size-sm text-muted">
                  on orders over $100. Special conditions may apply.{" "}
                  <Link href="/terms/shipping">
                    <a>See terms</a>
                  </Link>
                </p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-4">
            <div className="d-flex mb-6 mb-md-0">
              <i className="fe fe-lock font-size-lg text-primary"></i>

              <div className="ml-6">
                <h6 className="mb-1 heading-xxs">Secure shopping</h6>

                <p className="mb-0 font-size-sm text-muted">
                  Your information is always secure and is transmitted over SSL
                </p>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-4">
            <div className="d-flex mb-6 mb-md-0">
              <i className="fe fe-check font-size-lg text-primary"></i>

              <div className="ml-6">
                <h6 className="mb-1 heading-xxs">You're in good company</h6>

                <p className="mb-0 font-size-sm text-muted">
                  Trusted by thousands of #ChicBabes worldwide
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
});
